var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing-page-sell-get-instant-cash"},[_c('iframe',{staticClass:"jot-form",attrs:{"onload":"window.parent.scrollTo(0,0)","allowtransparency":"true","allowfullscreen":"true","allow":"geolocation","src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }